import styled from "styled-components";

export const InquiryContactList = styled.div`
  gap: 12px;
  width: 100vw;
  height: calc(100vh - 56px);
  padding: 16px;
  display: flex;
  overflow: auto;
  background: ${(props) => props.theme.colors.mainBg};
  flex-direction: column;
`;

export const ListTit = styled.h3`
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
`;

export const ListContent = styled.ul`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;
